import LogDetails from '@/components/app/LogDetails'
//issue 148
import moment from 'moment';
//issue 148
const { getList } = require('@/api/base_entity')

export default {
  'entityName': 'log',
  pagination: {
    'itemsPerPage': 5,
    'page': 1,
    'sortBy': 'insert_at',
    'descending': true
  },
  filterStorage: {},
  'fields': [
    {
      value: 'insert_at',
      text: 'Insert at',
      //issue 148
      filtertofrom: true,
      //issue 148
      'type': 'date',
      'table': {
        'sortable': true,
        'filter': true
      },
      tooltip: () => {
        return "Click to copy the REQUEST and RESPONSE json into the clipboard"
      },
      click: (item) => {
        const value = {
          REQUEST: item.request,
          RESPONSE: item.response
        }
        navigator.clipboard.writeText(JSON.stringify(value, null, 2))
      }
      //issue 148
      ,render(item) { return moment(item.account.insert_at).format('DD-MMM-YYYY HH:mm:ss')  }
      //issue 148
    },
    {
      value: 'account.surname',
      text: 'Account',
      'type': 'autocomplete',
      'table': {
        'sortable': false,
        'filter': true
      },
      filter: (item, search) => [{ 'account.name': `%${search}%`}, {'account.surname' : `%${search}%`}],
      render: item => `${item.account.name} ${item.account.surname} (${item.account.role})`,
    },
    // {
    //   value: 'route',
    //   text: 'Route',
    //   'type': 'text',
    //   'table': {
    //     'sortable': false,
    //     'filter': true
    //   },
    // },
    // {
    //   value: 'http_verb',
    //   text: 'HTTP Method',
    //   type: 'list',
    //   list: ['POST', 'PUT', 'DELETE'],
    //   'table': {
    //     'sortable': false,
    //     'filter': true
    //   },
    //   filter: (item, search) => { return { 'http_verb': `${search}` } },
    // },
    {
      value: '_protocol',
      type: 'search_autocomplete',
      text: 'Protocol',
      reference: 'protocol',
      title: 'name',
      id: 'id',
      list: (entity, search) => getList('protocol', { name: `%${search}%`}),
      //newlogs
      //render: item => (item?.response?.data?.protocol ?? item?.request?.protocol ?? item?.protocol)?.name,
      //filter: search => [{ response: `JSON(${search._protocol},$.data.protocol_id)` }, { request: `JSON(${search._protocol},$.protocol_id)` }],
      render: item => (item?.response?.data?.protocol ?? item?.protocol)?.name ?? '-',
      filter: (item, search) => [{ 'protocol_id': `${search}`} ],
      //newlogs
      table: {
        sortable: false,
        filter: true
      },
      width: 100
    },
    {
      value: 'action',
      text: 'Action',
      table: {
        sortable: false,
        filter: true,
      },  
    },
    {
      value: 'section',
      text: 'Section',
      width: 100,
      table: {
        sortable: false,
        filter: true,
      },      
    },
    {
      value: 'record',
      text: 'Details',
      table: {
        sortable: false,
        filter: false,
        component: LogDetails
      },
    },
  ],
  actions: [
    { "value": "audit_trail", disable: item => !item.entity_id },
  ]
}
